module.exports = __webpack_public_path__ + "static/3drender-ebde941c10972b77b4b856e404fb50ff.mp4";